/**
 * Translation library status. Only "Available" (approved) and "In Development" are offered
 * to admins; legacy/empty "pending" values are treated as In Development (same as the customer site).
 */

/** Modal select value ('Approved' | 'In Development' | 'Rejected') for a translation record. */
export function getTranslationStatusOption(translation) {
  const s = (translation?.adminStatus || translation?.status || '').toString().toLowerCase();
  if (s === 'approved') return 'Approved';
  if (s === 'rejected') return 'Rejected';
  return 'In Development';
}

/** API adminStatus value for a modal select value. Never returns 'pending'. */
export function toApiTranslationAdminStatus(status) {
  const s = (status || '').toString().toLowerCase();
  if (s === 'approved') return 'approved';
  if (s === 'rejected') return 'rejected';
  return 'in_development';
}
